(function () {
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var target = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!target) return;
      var isOpen = target.hasAttribute('open');
      if (isOpen) {
        target.removeAttribute('open');
      } else {
        target.setAttribute('open', '');
      }
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants-json]');
    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('[data-add-to-cart]');
    var product = form.closest('.product');
    var mediaItems = product ? Array.from(product.querySelectorAll('[data-product-media]')) : [];
    if (!json || !idInput || !submit) return;

    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }

    function selectedOptions() {
      return Array.from(form.querySelectorAll('[data-option-group]')).map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ß/g, 'ss')
        .replace(/ue/g, 'u')
        .replace(/[^a-z0-9]+/g, '');
    }

    function scrollToSelectedMedia(options) {
      if (!mediaItems.length) return;

      var keys = options.map(normalize).filter(Boolean);
      var target = mediaItems.find(function (media) {
        var mediaKey = normalize(media.dataset.mediaKey || '');
        return keys.some(function (key) {
          return mediaKey.indexOf(key) !== -1;
        });
      });

      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }

    function updateVariant() {
      var options = selectedOptions();
      var variant = variants.find(function (item) {
        return item.options.every(function (option, index) {
          return option === options[index];
        });
      });

      if (!variant) {
        submit.disabled = true;
        submit.textContent = submit.dataset.unavailableText;
        return;
      }

      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldOutText;
      scrollToSelectedMedia(options);
    }

    form.addEventListener('change', updateVariant);
  });
})();
